import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
var LogResolve = /** @class */ (function () {
    function LogResolve(logger) {
        this.logger = logger;
    }
    LogResolve.prototype.resolve = function (route) {
        this.logger.debug('route:', route);
        return true;
    };
    LogResolve.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LogResolve.ctorParameters = function () { return [
        { type: NGXLogger }
    ]; };
    return LogResolve;
}());
export { LogResolve };
//# sourceMappingURL=log.resolve.js.map